import dayjs from 'dayjs';

export default function getTimeString(date) {
  return dayjs(date).format('D MMM hh:mm a');
}
